import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import { BtDatasourcesModel } from './bt-datasources.model';

@Component({
  selector: 'dynamic-bt-datasources',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-bt-datasources.component.html'
})
export class DynamicBtDatasourcesComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() override group: FormGroup;
  @Input() override model: BtDatasourcesModel;
  @Output() override blur: EventEmitter<any> = new EventEmitter();
  @Output() override change: EventEmitter<any> = new EventEmitter();
  @Output() override customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() override focus: EventEmitter<any> = new EventEmitter();
  constructor(protected override layoutService: DynamicFormLayoutService, protected override validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
